// file is tsx to allow for jsx in the showBffMessage function
import { AppEvents } from 'utilities/EventBus';
import RichText from './components/rich-text/RichText';
import { pushToOmniture } from 'utilities/gtm';
import { TrackingData } from 'shared_logic/CP/types';
import type { ShowBffMessage } from './types/types';

export const pushToOmnitureBFF = (trackingData: TrackingData) => {
  if (trackingData?.omniturePayload?.event) {
    pushToOmniture(trackingData.omniturePayload);
  }
};

export const showBffMessage = (props: ShowBffMessage) => {
  const { message, title, tone } = props;
  AppEvents.emit('showToast', {
    show: true,
    message: (
      <div className="w-[358px] flex justify-center">
        <RichText text={message} themeColor="common.white" />
      </div>
    ),
    type: tone,
    persistUntilClear: false,
    title,
  });
};
